import axios from "../../utils/axios";

export const fetchDetails = async (id) => {
    const response = await axios.get(`/blogs/${id}`);

    return response.data
}
export const updateLike = async (info) => {
    const response = await axios.put(`/blogs/${info.id}`, { ...info, likes: info.likes + 1 })
    return response.data
}
export const updateSaved = async (info) => {
    const response = await axios.put(`/blogs/${info.id}`, { ...info, isSaved: !info.isSaved })
    return response.data
}